import { getStoredData, get_auth_key, storeData } from '../../util';
const { createSlice } = require('@reduxjs/toolkit');

export const account = createSlice({
  name: 'account',
  initialState: {
    isLoggedIn: false,
    detail: null,
    factoryId: localStorage.getItem('factoryId'),
    userRoles: [],
  },
  reducers: {
    setUserLogin: (state, action) => {
      let storedData = getStoredData(get_auth_key());
      if (storedData) {
        storedData = JSON.parse(storedData);
        if (storedData) {
          state.isLoggedIn = true;
          state.detail = {
            ...storedData,
          };
        } else {
          state.isLoggedIn = false;
          state.detail = null;
        }
      } else {
        state.isLoggedIn = false;
        state.detail = null;
      }
    },
    setUserLogout: (state, action) => {
      state.isLoggedIn = false;
      state.detail = null;
    },
    setAppFactory: (state, action) => {
      state.factoryId = action.payload || null;
      // storeData(get_auth_key(), JSON.stringify({ ...state.detail }));
    },
    setUserRoles: (state, action) => {
      state.userRoles = action.payload;
    },
  },
});

export const { setUserLogin, setAppFactory, setUserLogout, setUserRoles } = account.actions;
export const isLoggedIn = (state) => state.account.isLoggedIn;
export const loggedInUser = (state) => state.account.detail;
export const factoryId = (state) => parseInt(state.account.factoryId);
export const userRoles = (state) => state.account.userRoles;
export default account.reducer;
